import { format, parseISO } from "date-fns";
import MarkdownContent from "./MarkdownContent";

interface BlogPostContentProps {
  title: string;
  date: string;
  content: string;
}

const BlogPostContent = ({ title, date, content }: BlogPostContentProps) => {
  return (
    <article className="max-w-4xl mx-auto">
      <p className="text-sm text-gray-400 mb-3">
        {format(parseISO(date), "MMMM d, yyyy")}
      </p>
      <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">{title}</h1>
      <div className="prose prose-lg max-w-none prose-invert prose-headings:text-white prose-p:text-gray-300 prose-strong:text-white prose-a:text-blue-400 prose-a:no-underline hover:prose-a:underline prose-li:text-gray-300 prose-code:text-gray-300">
        <MarkdownContent content={content} />
      </div>
    </article>
  );
};

export default BlogPostContent;
